<template>
  <div id="app">
    <v-app>
      <MainNav v-if="!isFullScreen"/>
      <div id="content">
        <router-view/>
      </div>
      <Footer v-if="!isFullScreen"/>
      <notifications position="top right"/>
    </v-app>
  </div>
</template>

<script>
  import MainNav from "@/ui/components/layout/MainNav";
  import Footer from "@/ui/components/layout/Footer";

  export default {
    components: {Footer, MainNav},
    computed: {
      isFullScreen() {
        return this.$store.getters.isFullScreen
      }
    }
  }
</script>

<style>
  @import './assets/css/custom.css';
  @import './assets/css/vue-notification.css';

  #content {
    min-height: calc(100vh - 118px);
  }
</style>
